import { render, staticRenderFns } from "./AttachmentUpload.vue?vue&type=template&id=eb0bf062&scoped=true&lang=pug&"
import script from "./AttachmentUpload.vue?vue&type=script&lang=js&"
export * from "./AttachmentUpload.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentUpload.vue?vue&type=style&index=0&id=eb0bf062&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0bf062",
  null
  
)

/* custom blocks */
import block0 from "./AttachmentUpload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports